import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import Input from '../../components/input/input';
import ScrollArea from '../../components/scroll-area/scroll-area';
import Validation from '../../components/validation/validation';

class SystemUserFormPage extends React.PureComponent {
    state = {
        email: this.props.model ? this.props.model.email : ''
    };

    setValue = prop => value => {
        this.setState({
            [prop]: value
        });
    };

    render() {
        return (
            <div className="sten-content sten-system-user-form-page">
                <div className="sten-content__header flex-row">
                    <div className="flex-shrink">
                        <a rel="prev" className="btn-link icon" href="/systemUsers" title="Back to System Users list">
                            <span className="icon icon-arrow-left" />
                        </a>
                    </div>
                    <div className="flex-grow">
                        <h1 className="sten-content__title text-uppercase">Create New System User</h1>
                    </div>
                </div>
                <ScrollArea className="sten-content__body">
                    <Validation.Form method="post" name="Create">
                        <div className="sten-content__section">
                            <div className="row">
                                <div className="col-md-6 col-xs-24">
                                    <label className="label">Email</label>
                                    <Validation.Wrapper
                                        validations={{ required: true, minLength: 2, maxLength: 50, email: true }}
                                    >
                                        <Input
                                            name="Email"
                                            type="text"
                                            value={this.state.email}
                                            onChange={this.setValue('email')}
                                            placeholder="Enter User Email"
                                        />
                                    </Validation.Wrapper>
                                    <p className="sten-system-user-form-page__info-text">
                                        Info:&nbsp;
                                        <span className="text-secondary">
                                            User will receive email instructions on how to set up a password
                                            and complete account creation process
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-md-3 col-xs-12">
                                    <a href="/systemUsers" className="btn btn--secondary col-24">Cancel</a>
                                </div>
                                <div className="col-md-3 col-xs-12">
                                    <Validation.Button className="btn btn--primary col-24">
                                        Create User
                                    </Validation.Button>
                                </div>
                            </div>
                        </section>
                        <input type="hidden" name="IsActive" value />
                        <input type="hidden" name="LocalLoginEnabled" value />
                        <input type="hidden" name="__RequestVerificationToken" value={this.props.token} />
                    </Validation.Form>
                </ScrollArea>
            </div>
        );
    }
}

SystemUserFormPage.defaultProps = {
    model: null
};

SystemUserFormPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any)
};

export default SystemUserFormPage;
